import React from "react";

/**
 * A consistent header component for section cards
 */
export function CardHeader({ 
  icon,
  title, 
  description = "",
  className = ""
}) {
  return (
    <div className={`flex items-center gap-4 mb-6 ${className}`}>
      {icon && (
        <div className="p-3 rounded-lg bg-primary/10">
          {React.cloneElement(icon, { className: "w-6 h-6 text-primary" })}
        </div>
      )}
      <div>
        <h2 className="card-title text-lg font-semibold">{title}</h2>
        {description && (
          <p className="text-base-content/60 text-sm">{description}</p>
        )}
      </div>
    </div>
  );
} 